import { useEffect, useState } from 'react'
import {
  collection,
  limit as fbLimit,
  onSnapshot,
  orderBy,
  query,
  where
} from 'firebase/firestore'
import { db } from '@/firebase'

interface PlatformMail {
  id: string
  subject: string
  body: string
  state: string
  createdAt: string
  lastUpdated: string
  recipientCount: number
}

const usePlatformMails = (limit = 50) => {
  const [mails, setMails] = useState<PlatformMail[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const q = query(
      collection(db, 'platformmail'),
      where('siteId', '==', '_platform'),
      orderBy('createdAt', 'desc'),
      fbLimit(limit)
    )
    const unsub = onSnapshot(
      q,
      (snap) => {
        setMails(
          snap.docs.map((d) => {
            const data = d.data()
            return {
              id: d.id,
              subject: data.subject || '',
              body: data.body || '',
              state: data.state || 'unknown',
              createdAt: data.createdAt || '',
              lastUpdated: data.lastUpdated || '',
              recipientCount: Array.isArray(data.to) ? data.to.length : 0
            }
          })
        )
        setLoading(false)
      },
      (err) => {
        console.error('Failed to fetch platform mails', err)
        setLoading(false)
      }
    )
    return () => unsub()
  }, [limit])

  return { mails, loading }
}

export { usePlatformMails }
export type { PlatformMail }
